import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export type KycStatus = 'PENDING' | 'REQUIRED' | 'REVIEWING' | 'VERIFIED' | 'REJECTED';

export interface KycProfile {
  id: string;
  creatorProfileId: string;
  status: KycStatus;
  provider?: string;
  providerSessionId?: string;
  country?: string;
  documentType?: string;
  documentLast4?: string;
  fullName?: string;
  dob?: string;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  failedReason?: string;
  reviewedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const kycService = {
  async getMyStatus() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/kyc/me`, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { status: 'PENDING'|'APPROVED'|'REJECTED'; documents: any[] };
  },
  async upload(doc: { docType: 'ID_CARD'|'PASSPORT'|'ADDRESS_PROOF'|'TAX_FORM'; fileUrl: string; note?: string }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/kyc/upload`, doc, { headers: { Authorization: `Bearer ${token}` } });
    return res.data as { document: any };
  },
};
